type ApplicationEnvironment =
  | 'local-local'
  | 'local-dev'
  | 'local-staging'
  | 'local-production'
  | 'development'
  | 'staging'
  | 'production';

type BackendEnvironment = 'local' | 'dev' | 'staging' | 'production';

const MODE = import.meta.env.MODE as ApplicationEnvironment;

const BACKEND_ENV: BackendEnvironment =
  {
    'local-local': 'local' as const,
    'local-dev': 'dev' as const,
    'local-staging': 'staging' as const,
    'local-production': 'production' as const,
    development: 'dev' as const,
    staging: 'staging' as const,
    production: 'production' as const,
  }[MODE] ?? 'dev';

const SENTRY_DSN = import.meta.env.VITE_SENTRY_DSN;
const SENTRY_ENVIRONMENT = import.meta.env.VITE_SENTRY_ENVIRONMENT;

const PUBLIC_POSTHOG_HOST = import.meta.env.VITE_PUBLIC_POSTHOG_HOST;
const PUBLIC_POSTHOG_KEY = import.meta.env.VITE_PUBLIC_POSTHOG_KEY;

const API_BASE_URL = import.meta.env.VITE_API_BASE_URL;
const MOCK_SERVER_BASE_URL = import.meta.env.VITE_MOCK_SERVER_BASE_URL;
const AS2_BASE_URL = import.meta.env.VITE_AS2_BASE_URL;
const AS2_MDN_RECEIVE_URL = import.meta.env.VITE_AS2_MDN_RECEIVE_URL;
const AS2_PROCUROS_ID = import.meta.env.VITE_AS2_PROCUROS_ID;

const DOCUPARSE_API_URL = import.meta.env.VITE_DOCUPARSE_API_URL;
const DOCUPARSE_API_KEY = import.meta.env.VITE_DOCUPARSE_API_KEY;

const VITE_PYLON_PORTAL_URL = import.meta.env.VITE_PYLON_PORTAL_URL;

const FEATURE_FLAG: Record<string, string | boolean | undefined> = {};

const SENTRY_RELEASE = import.meta.env.VITE_SENTRY_RELEASE;

const ADMIN_UI_URL = import.meta.env.VITE_ADMIN_UI_URL;

const KNOCK_API_KEY = import.meta.env.VITE_PUBLIC_KNOCK_API_KEY;
const KNOCK_GUIDE_CHANNEL_ID = import.meta.env.VITE_PUBLIC_KNOCK_GUIDE_CHANNEL_ID;

export const ENV = {
  MODE,
  BACKEND_ENV,
  SENTRY_DSN,
  SENTRY_ENVIRONMENT,
  PUBLIC_POSTHOG_HOST,
  PUBLIC_POSTHOG_KEY,
  API_BASE_URL,
  AS2_BASE_URL,
  AS2_MDN_RECEIVE_URL,
  AS2_PROCUROS_ID,
  FEATURE_FLAG,
  SENTRY_RELEASE,
  MOCK_SERVER_BASE_URL,
  DOCUPARSE_API_URL,
  DOCUPARSE_API_KEY,
  VITE_PYLON_PORTAL_URL,
  ADMIN_UI_URL,
  KNOCK_API_KEY,
  KNOCK_GUIDE_CHANNEL_ID,
};
